import React from 'react'

const FillinIcon = () => (

	<svg
		className="fillin"
		stroke="currentColor"
		fill="none"
		strokeWidth="2"
		viewBox="0 0 24 24"
		strokeLinecap="round"
		strokeLinejoin="round"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>Fill-in</title>
		<path d="M16 7h.01"></path>
		<path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"></path>
		<path d="m20 7 2 .5-2 .5"></path>
		<path d="M10 18v3"></path>
		<path d="M14 17.75V21"></path>
		<path d="M7 18a6 6 0 0 0 3.84-10.61"></path>
	</svg>
)

export default FillinIcon
